<template lang="pug">
  div.payment.invoice-create
    e-modal(
    ref="modalForm"
    @confirm="sendForm()"
    @close="closeForm()"
    title="Сформировать квитанции"
    saveBtnLabel="Сформировать"
    :hideDeleteButton="false"
    :centered="true"
    :autoHeight="true"
    )
      slot
        // чтобы список адресов был полнтсью виден
        // убираем скрол и меняем класс формы
        // иначе его конец спрчетсчя за футером
        e-form(
        :formValidator="formValidator"
        :enablePerfectScrollbar="false"
        formClass="fix-elements-overflow-problem"
        )
          div.body
            div.col
              e-form-group(
              name="_locationType"
              inputType="select"
              label="Объект расчета"
              :model="fields"
              tabView="tab1"
              :options="locationTypes"
              :required="true"
              )

              e-form-group(
              v-if="fields._locationType===INVOICE_TYPE_ADDRESS"
              key="INVOICE_TYPE_ADDRESS"
              name="address"
              inputType="address"
              addressProvider="tree"
              :model="fields"
              tabView="tab1"
              formGroupStyle=""
              )

              e-form-group(
              v-else-if="fields._locationType===INVOICE_TYPE_POST"
              key="INVOICE_TYPE_POST"
              tabView="tab1"
              :model="fields"
              label="Почтовое отделение"
              placeholder="Начните вводить название либо индекс либо адрес"
              inputType="suggestion"
              name="pochtamtName"
              realName="pochtamt_index"
              :options="postOffices"
              :useInnerSearch="true"
              :minSuggestLen="0"
              :maxShowedOptions="Infinity"
              :required="true"
              :dontShowErrorInFinishComponent="true"
              )

              e-form-group(
              name="date"
              inputType="calendar"
              label="Период"
              :model="fields"
              tabView="tab1"
              :required="true"
              type="month"
              format="MM/yyyy"
              )


</template>

<script>
  import {payment, core} from "../../api/api-endpoints"
  import invoiceFromMixin from "./mixins/invoice-form"

  export default {
    mixins: [invoiceFromMixin],
    methods: {
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return null
      },
      getUpdateOrCreateUrl () {
        return payment.createInvoices()
      },
      getPostOfficesEndpoint () {
        return core.postOffices({
          query: {
            'per-page': -1
          }
        })
      }
    }
  }
</script>
